export default __webpack_public_path__ + "static/media/spectra-com18.bdd1c7d7.jpg";